import React from "react";
import Site from "../../model/Site";
import { useNavigate } from "react-router";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ImgUtil from "../../utils/ImgUtil";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import ButtonInfo from "../common/button/ButtonInfo";
import AppIcons from "../../utils/AppIcons";
import TimeUtil from "../../utils/TimeUtil";
import EntityStats from "../../model/EntityStats";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";

interface ISitesGridElementProps {
  data: Site;
  canEdit: boolean;
  onRemove: (id: number) => void;
}

function SitesGridElement({ data, canEdit, onRemove }: ISitesGridElementProps) {
  // reference to the navigator
  const navigate = useNavigate();

  return (
    <div
      className="details-grid-element"
      onClick={() => {
        navigate(
          SETTINGS.get_path({
            section: AppSections.SITES,
            id: data.id!,
            subsection: AppSubSections.VIEW,
          })
        );
      }}
    >
      <div className="details-remove-element">
        <Button
          purpose={ButtonAction.CANCEL}
          type={ButtonType.ICON}
          label=""
          onClick={() => onRemove(data.id!)}
        />
      </div>
      <div
        className="details-grid-icon"
        style={{
          backgroundImage: `url(${ImgUtil.display_icon(data.icon_path)})`,
        }}
      ></div>
      <div className="details-grid-content">
        <div className="details-grid-description">
          <div>
            <h3>{data.name}</h3>
            { canEdit &&
            <Button
              label="Edit"
              className="mr-0"
              purpose={ButtonAction.EDIT}
              type={ButtonType.ICON}
              onClick={() =>
                navigate(
                  SETTINGS.get_path({
                    section: AppSections.SITES,
                    id: data.id,
                    subsection: AppSubSections.EDIT,
                  })
                )
              }
            />}
          </div>
          <p>{data.description}</p>
        </div>
        <div className="details-grid-statistics">
          <ButtonInfo>
            {AppIcons.CLOCK}
            created on <span>{TimeUtil.display_date(data.created_on)}</span>
          </ButtonInfo>
          <ButtonInfo>
            {AppIcons.USER}
            created by: <span>{data.username}</span>
          </ButtonInfo>
          <div></div>
          <ButtonInfo>
            {AppIcons.CH_ELEMENT}
            <span>
              {EntityStats.getStats(data.counts, ChemiNovaEntityType.CHELEMENT)}
            </span>
            CH Elements
          </ButtonInfo>
          <ButtonInfo>
            {AppIcons.DOCUMENTS}
            <span>
              {EntityStats.getStats(
                data.counts,
                ChemiNovaEntityType.ANNEX_DATA
              )}
            </span>
            documents
          </ButtonInfo>
        </div>
      </div>
    </div>
  );
}

export default SitesGridElement;
